// Accordion
export const SET_OPENED_COLLAPSE_NAME = 'SET_OPENED_COLLAPSE_NAME'
//

export const PRODUCT_QUANTITY_EDITED = 'Product Quantity Edited'
export const PRODUCT_REMOVED = 'Product Removed'
export const PRODUCT_LIST_VIEWED = 'Product List Viewed'
export const ALERT_DISPLAYED = 'Alert Displayed'

export const BUTTON_CLICKED = 'Button Clicked'

export const VS_LINK_ORDER_TAKING = 'LINK_ORDER_TAKING'
export const VS_LINK_PLANNING = 'LINK_PLANNING'
export const SECTION_NAME = 'categories'
export const SCREEN_NAME = 'Home'
export const HOMEPAGE_SCREEN_NAME = 'Cms Index Home'
